/** Client-side aircraft filtering (altitude / type / emergency / ground). */

import type { Aircraft, Filters, TypeFilter } from '../types';
import { EMERGENCY_SQUAWKS, isParked } from '../types';
import { shapeFor, type PlaneShape } from './planeIcon';

const TYPE_GROUPS: Record<Exclude<TypeFilter, 'all'>, PlaneShape[]> = {
  airliner: ['jet', 'heavy'],
  ga: ['prop', 'glider', 'balloon', 'uav'],
  heli: ['heli'],
  military: ['fast'],
};

export function matchesFilters(ac: Aircraft, f: Filters): boolean {
  if (!f.showGround && ac.onGround) return false;
  if (f.showParked === false && isParked(ac)) return false;
  if (f.emergencyOnly && !(ac.squawk && EMERGENCY_SQUAWKS.has(ac.squawk))) return false;
  if (f.minAltFt != null && (ac.altitudeFt == null || ac.altitudeFt < f.minAltFt)) return false;
  if (f.maxAltFt != null && (ac.altitudeFt == null || ac.altitudeFt > f.maxAltFt)) return false;
  if (f.types !== 'all') {
    const shapes = TYPE_GROUPS[f.types];
    if (!shapes.includes(shapeFor(ac.category))) return false;
  }
  if (f.model && ac.typeCode !== f.model) return false;
  return true;
}

export function isDefaultFilters(f: Filters): boolean {
  return (
    f.minAltFt == null &&
    f.maxAltFt == null &&
    f.showGround &&
    f.showParked !== false &&
    !f.emergencyOnly &&
    f.types === 'all' &&
    f.model == null
  );
}
